import { GridColDef } from "@mui/x-data-grid-pro";

import ItemStatus from "../../../../../../common/components/item_status";
import dayjs from "dayjs";

/**
 * GenerateTreinamentosColumnsDefinition
 */

export const GenerateTreinamentosColumnsDefinition = (): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 2: return "A";
      case 1: return "D";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 2: return "red";
      case 1: return "blue";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 2: return "Avaliação em atraso";
      case 1: return "Avaliação dentro do prazo";
      default:
        return "?";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      width: 65,
      sortable: false,
      align: 'center',
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)} />
        </div>
      )
    },
    {
      field: "funcionario",
      filterable: false,
      headerName: "Funcionário",
      flex: 1,
      minWidth: 130,
      sortable: false,
      align: 'left',
      renderCell: ({ value }) => (
        <div className="w-full h-full flex items-center">
          {value}
        </div>
      ),
    },
    {
      field: "cargo",
      filterable: false,
      headerName: "Cargo",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex items-center">
          {value}
        </div>
      ),
    },
    {
      field: "centroCusto",
      filterable: false,
      headerName: "Centro de Custo",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex items-center">
          {value}
        </div>
      ),
    },
    {
      field: "treinamento",
      filterable: false,
      headerName: "Treinamento",
      flex: 1,
      minWidth: 85,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex items-center">
          {value}
        </div>
      ),
    },
    {
      field: "instrutor",
      filterable: false,
      headerName: "Instrutor",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex items-center">
          {value}
        </div>
      ),
    },
    {
      field: "dataInicio",
      filterable: false,
      headerName: "Data",
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex items-center">
          {params.value && dayjs(params.value).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      field: "dataPrevAvaliacao",
      filterable: false,
      headerName: "Data Prev. Avaliação",
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex items-center">
          {params.value && dayjs(params.value).format("DD/MM/YYYY")}
        </div>
      ),
    },
  ];
}
